import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { TextField as MuiTextField } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const styles = theme => ({
  root: {
    height: 41,
    display: 'flex',
    letterSpacing: 1,
    borderRadius: 100,
    position: 'relative',
    alignItems: 'center',
    justfiyContent: 'flex-start',
    border: '1px solid #e0e2e5',
    padding: `0 ${theme.spacing(2)}px`,
  },
  placeholder: {
    top: 9,
    left: 45,
    fontSize: 16,
    position: 'absolute',
    pointerEvents: 'none',
    transition: 'all .2s ease',
    color: theme.palette.text.disabled,
  },
})

class TextField extends React.PureComponent {
  state = {
    value: '',
    focused: false,
  };

  onChange = (event) => {
    const { value } = event.target
    this.setState({ value })
    if (this.props.onChange) {
      this.props.onChange(value)
    }
  };

  render() {
    const { value, focused } = this.state
    const {
      classes,
      className,
      width,
      hintText,
      onChange,
      ...fieldProps
    } = this.props

    return (
      <div className={classNames(classes.root, className)}>
        <MuiTextField
          onChange={this.onChange}
          value={this.state.value || ''}
          style={{ width }}
          InputProps={{
            disableUnderline: true,
          }}
          {...fieldProps}
        />
        {value.length === 0 && (
          <div
            className={classes.placeholder}
            style={{ transform: focused ? 'translateX(6px)' : 'none' }}>
            <Typography style={{ fontSize: 16 }}>
              {hintText}
            </Typography>
          </div>
        )}
      </div>
    )
  }
}

TextField.defaultProps = {
  delay: 0,
  width: 200,
  onChange: () => { },
}

TextField.propTypes = {
  delay: PropTypes.number,
  width: PropTypes.number,
  onChange: PropTypes.func,
  classes: PropTypes.object,
  hintText: PropTypes.string,
  className: PropTypes.string,
}

export default withStyles(styles)(TextField)



// WEBPACK FOOTER //
// ./src/components/atoms/TextField.js